import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as _ from "lodash";
import { DesignphotoService } from "../../../services/designphoto.service";
import { MatProgressSpinnerModule } from "@angular/material";
@Component({
  selector: "design-photo-list",
  templateUrl: "designPhotoList.html",
})
export class designPhotoList implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  mode: string;
  dataList = [];
  IsWait: boolean = false;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  exceldata: any;
  headerData: any;
  orderList = [];
  filter = {
    design_no: "",
    code: "",
    from_date: "",
    to_date: "",
    start: 0,
    limit: 100,
  };
  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private designPhoto: DesignphotoService,
    private spin: MatProgressSpinnerModule
  ) {}

  ngOnInit(): void {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);

    this.getDesignPhotoList();
  }

  applyFilterNext() {
    this.filter.start += 100;
    this.getDesignPhotoList();
  }

  applyFilterPrev() {
    if (this.filter.start != 0) {
      this.filter.start -= 100;
    }

    this.getDesignPhotoList();
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
  getDesignPhotoList() {
    this.IsWait = true;

    let params = {};

    params["filter"] = JSON.stringify(this.filter);
    let that = this;
    that.loadingIndicator = true;
    that.designPhoto.getDesignPhotoList(params).then((res: any) => {
      that.IsWait = false;
      that.loadingIndicator = false;
      that.orderList = res.data;
      that.gridOptions = {
        cols: res.cols,
        columns: res.columns,
        data: res.data,
        loading: false,
      };
    });
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/designPhotoList/designPhotoList.ts